export function genderParser(gender: string | number) {
    if (gender == 0) return 'Мужчина'
    if (gender == 1) return 'Женщина'
}
